import { ANALYTICS_CATEGORY_HOTELS } from '@/constants/analytics'

const imageFolder =
  'https://s1.pclncdn.com/design-assets/next-landing/assets/images/home-deal-tiles/'

const HOTELS_DEAL_MODULE_CONTENT = {
  heading: "Don't miss these hotel deals",
  headingMobile: "Don't miss these deals!",
  dataArray: [
    {
      id: 'HOTEL_DEAL_TILE_VEGAS',
      image: `${imageFolder}vegas.jpg?opto&auto=avif,webp`,
      imageWebP: `${imageFolder}vegas.jpg?opto&auto=avif,webp`,
      imageHeight: '284px',
      cityName: 'Las Vegas',
      description: '',
      gaAction: 'Hotel Deal Tile',
      gaCategory: ANALYTICS_CATEGORY_HOTELS,
      productName: 'GET YOUR GAME ON',
      priceAmount: 15,
      pricePrefix: 'From',
      navArray: [
        {
          href: '/hotel-deals/c3000015284/US/Nevada/Las-Vegas-Hotels.html',
          target: '_blank'
        }
      ]
    },
    {
      id: 'HOTEL_DEAL_TILE_CHICAGO',
      image: `${imageFolder}chicago.jpg?opto&auto=avif,webp`,
      imageWebP: `${imageFolder}chicago.jpg?opto&auto=avif,webp`,
      imageHeight: '284px',
      cityName: 'Chicago',
      description: '',
      gaAction: 'Hotel Deal Tile',
      gaCategory: ANALYTICS_CATEGORY_HOTELS,
      productName: 'ALL THAT JAZZ',
      priceAmount: 44,
      pricePrefix: 'From',
      navArray: [
        {
          href: '/hotel-deals/c3000005381/US/Illinois/Chicago-Hotels.html',
          target: '_blank'
        }
      ]
    },
    {
      id: 'HOTEL_DEAL_TILE_BOSTON',
      image: `${imageFolder}boston.jpg?opto&auto=avif,webp`,
      imageWebP: `${imageFolder}boston.jpg?opto&auto=avif,webp`,
      imageHeight: '284px',
      cityName: 'Boston',
      description: '',
      gaAction: 'Hotel Deal Tile',
      gaCategory: ANALYTICS_CATEGORY_HOTELS,
      productName: 'FREEDOM TRAIL FUN',
      priceAmount: 65,
      pricePrefix: 'From',
      navArray: [
        {
          href: '/hotel-deals/c3000008602/US/Massachusetts/Boston-Hotels.html',
          target: '_blank'
        }
      ]
    }
  ]
}

export default HOTELS_DEAL_MODULE_CONTENT
